/**
 * Print-time layout choices for a proposal. Just before printing, try each
 * variant at the printed page's size and keep the one that fits more of the
 * document on the first page. A tie keeps the default.
 *
 * Today the only variant is the contents in two columns (when there is no
 * appendix, the contents is one list). The page size matches `@page` in
 * proposal-print.css: US Letter with 0.6in sides and top, 0.7in bottom.
 */
const PX_PER_IN = 96;
const PAGE_WIDTH = (8.5 - 0.6 * 2) * PX_PER_IN;
const PAGE_HEIGHT = (11 - 0.6 - 0.7) * PX_PER_IN;

/** How many of the article's top-level blocks fit, in order, on the first page. */
function blocksOnFirstPage(article: HTMLElement): number {
  const top = article.getBoundingClientRect().top;
  let n = 0;
  for (const child of Array.from(article.children)) {
    if (child.getBoundingClientRect().bottom - top > PAGE_HEIGHT) break;
    n += 1;
  }
  return n;
}

export function fitForPrint(article: HTMLElement): void {
  delete article.dataset.contents;
  if (!article.querySelector("nav[aria-label='Contents'] ol:only-child")) return;
  const width = article.style.width;
  article.style.width = `${PAGE_WIDTH}px`;
  article.dataset.measure = '';
  const single = blocksOnFirstPage(article);
  article.dataset.contents = 'two';
  const two = blocksOnFirstPage(article);
  if (two <= single) delete article.dataset.contents;
  delete article.dataset.measure;
  article.style.width = width;
}

export function clearPrintFit(article: HTMLElement): void {
  delete article.dataset.contents;
}
